export default __webpack_public_path__ + "static/media/Ring of Memory.265bf5e2.jpg";